module.exports = __webpack_public_path__ + "img/logo.d6b99519.svg";